var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.6665C4.31729 14.6665 1.33341 11.6826 1.33341 7.99984C1.33341 4.31704 4.31729 1.33317 8.00008 1.33317C11.6829 1.33317 14.6667 4.31704 14.6667 7.99984C14.6667 11.6826 11.6829 14.6665 8.00008 14.6665ZM8.77696 10.8063L6.74739 8.86005L11.656 8.86005C12.0135 8.86005 12.3012 8.57242 12.3012 8.21489L12.3012 7.78478C12.3012 7.42726 12.0135 7.13962 11.656 7.13962L6.74739 7.13962L8.77696 5.19339C9.03772 4.94339 9.04309 4.52672 8.78772 4.27134L8.49202 3.97833C8.23933 3.72564 7.83073 3.72564 7.58073 3.97833L4.01352 7.54285C3.76083 7.79554 3.76083 8.20414 4.01352 8.45414L7.58073 12.024C7.83341 12.2767 8.24202 12.2767 8.49202 12.024L8.78772 11.731C9.04309 11.473 9.03772 11.0563 8.77696 10.8063Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-left.bacfc2e7c992d344d916a306f7f795cc.svg";
export { ForwardRef as ReactComponent };